import * as app from 'actions/app';
import * as chat from 'actions/chat';
import * as webRTC from 'actions/chat/webrtc';
import Immutable from 'immutable';

export const WEB_RTC_DEVICE_KIND = {
  input: {
    video: 'videoInput',
  },
};

const initialState = {
  session: undefined,
  mode: undefined,
  loading: false,
  error: undefined,
  started: false,
  canPublishVideo: false,
  chosenCamera: undefined,
};

const loadingActions = [
  webRTC.START_REQUEST
];
const notLoadingActions = [
  webRTC.START
];
const errorActions = [
  webRTC.START_FAIL,
  webRTC.CLIENT_ERROR,
  webRTC.DETECTION_FAILED,
  webRTC.DEVICES_GET_FAILED,
];

const reducer = (state = {
  technology: undefined,
  supportedByAgent: undefined,
  devices: Immutable.Map(),
  ...initialState
}, action) => {
  if (loadingActions.some(a => a === action.type)) {
    state = { ...state, loading: true };
  }
  if (notLoadingActions.some(a => a === action.type)) {
    state = { ...state, loading: false };
  }
  if (errorActions.some(a => a === action.type)) {
    state = { ...state, loading: false, error: action.error };
  }
  if ([webRTC.END, chat.ENDED].includes(action.type)) {
    return { ...state, ...initialState };
  }

  switch (action.type) {
    case webRTC.DETECTED:
      return { ...state, technology: action.technology };
    //  We're ignoring webRTC.NOT_DETECTED here
    case webRTC.DEVICES_GET:
      return { ...state,
        devices: Immutable.Map(
          new Map(action.devices.map(d => [d.deviceId, d]))
        ),
        canPublishVideo: action.devices.some(d => d.kind === WEB_RTC_DEVICE_KIND.input.video),
      };
    case webRTC.AGENT_SUPPORTED:
      return { ...state, supportedByAgent: true };
    case webRTC.AGENT_NOT_SUPPORTED:
      return { ...state, supportedByAgent: false };
    case webRTC.START_REQUEST:
      return { ...state, started: true, mode: action.mode };
    case webRTC.START:
      return { ...state, session: action.webRTCSession };
    case webRTC.CHOOSE_CAMERA:
      return { ...state, chosenCamera: action.camera };
    case app.RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./reducers/chat/webrtc.js